$('.select-hymnal').chosen({
  disable_search_threshold: 10,
  placeholder_text: __('Select Worship Resources')
});
